export default [
  {
    path: "/products",
    name: "products",
    component: () => import("../views/masterdata/products/ProductsView.vue"),
  },
  {
    path: "/products/create",
    name: "products-create",
    component: () =>
      import("../views/masterdata/products/form/ProductsForm.vue"),
  },
  {
    path: "/products/update/:uuid",
    name: "products-update",
    component: () =>
      import("../views/masterdata/products/form/ProductsForm.vue"),
  },
];
